const moment = require('moment');
/**
 * @class StoreService
 */
function StoreService($q, $root, $indexedDB, storeBackend, $log, localStorageService, Notification) {
    var self = this,
        LASTUPDATED_KEY = 'user.stores.lastupdated',
        DIRTY_IDS_KEY = 'user.stores.modified';

    self.stores = false;

    self.cache = {};


    function prune(store) {
        delete store.conges;
        delete store.horaires_ouverture;
        delete store.infos_reprise;
        Object.keys(store)
            .filter(function(key) {
                return /^(category_ca|module|code_srd)/.exec(key);
            })
            .forEach(function(key) {
                delete store[key];
            });
        var q = store.qualification;
        delete store.qualification;
        if (q) {
            store.qualification = {
                fournisseur: q.fournisseur,
                fin_contrat: q.fin_contrat
            };
        }
        return store;
    }

    /**
     * Get stores list
     * @returns {d.promise}
     */
    self.get = function() {
        var d = $q.defer();
        if (self.stores) {
            d.resolve({
                success: true,
                stores: self.stores
            });
        }
        else {
            $indexedDB.openStore('Stores', function(objectStore) {
                objectStore.getAll().then(
                    function(res) {
                        self.stores = (res || []).map(prune);
                        var storePromise;
                        storePromise = self.getLastAppointmentsForEachStores(self.stores);
                        storePromise.then(function(response) {
                            self.stores = self.mapStoresAndLastAppointment(self.stores, response);
                            d.resolve({
                                success: true,
                                stores: self.stores
                            });
                        });
                    },
                    function(err) {
                        d.reject({
                            success: false,
                            error: err
                        });
                    }
                );
            });
        }
        return d.promise;
    };

    function storeIdFilter(storeid) {
        return function(s) {
            return s.identifiant_magasin === storeid;
        };
    }

    /**
     * Get store from id
     * @returns {d.promise}
     */
    self.getById = function(identifiant_magasin) {
        return $q(function(resolve, reject) {
            var matches,
                filter = storeIdFilter(identifiant_magasin);

            // try from geocache
            // var entry = Object.keys(self.cache)[0];
            // if (entry) {
            //     matches = (self.cache[entry].stores || []).filter(filter);
            //     if (matches[0]) {
            //         return resolve(matches[0]);
            //     }
            // }
            $indexedDB.openStore('Stores', function(objectStore) {
                return objectStore.findBy('identifiant_magasin_idx', identifiant_magasin).then(
                    function(store) {
                        if (store && store.client[0].id !== null) {
                            return resolve(store);
                        }
                        storeBackend.downloadStore(identifiant_magasin).then(function(res) {
                            let data = res.data;
                            if (data && data[0]) {
                                resolve(data[0]);
                            }
                            else {
                                reject(new Error('magasin inconnu.'));
                            }
                        }, reject);
                    },
                    function(err) {
                        $log.info('impossible de trouver le magasin', identifiant_magasin, 'en local');
                        return reject(err);
                    }
                );
            });
        });
    };

    /**
     * Recherche les magasins aus alentours
     * @param location
     * @returns {d.promise}
     */
    self.searchAround = function(location) {
        var d = $q.defer();

        function success(data) {

            var storePromise;
            storePromise = self.getLastAppointmentsForEachStores(data);
            storePromise.then(function(response) {
                data = self.mapStoresAndLastAppointment(data, response);
                var r = {
                    success: true,
                    stores: data
                };
                self.cache = {};
                self.cache[location] = r;
                d.resolve(self.cache[location]);
            });
        }

        if (self.cache[location]) {
            d.resolve(self.cache[location]);
        }
        else {
            storeBackend.searchAround(location).then(success, function(err) {
                d.reject({
                    success: false,
                    error: err
                });
            });
        }

        return d.promise;
    };

    self.searchAroundAddress = function(address) {
        return storeBackend.searchAroundAddress(address);
    }

    self.searchAroundManyAddress = function (data){
    var d = $q.defer();
    let stores = [];

    const references = JSON.parse(data.split('?')[0]);

    let promises = references.map(ref => {
        let location = ref.latitude+','+ref.longitude+'?'+data.split('?')[1];
        return storeBackend.searchAround(location);
    });

    $q.all(promises).then(results => {
        results.forEach((res,index) => {
            res.forEach(store => {
                if(store.adgency){
                    store.adgency.reference = references[index];
                } else {
                    store.adgency = {};
                    store.adgency.reference = references[index];
                }
                stores.push(store)
            });
        });
        d.resolve({success: true, stores: stores});
    }, d.reject.bind(d));

    return d.promise;
}

    /**
     * Recherche full text
     * @param query
     * @returns {d.promise}
     */
    self.search = function(query) {
        var d = $q.defer(),
            key = JSON.stringify(query);

        function success(data) {
            var storePromise;
            storePromise = self.getLastAppointmentsForEachStores(data);
            storePromise.then(function(response) {
                data = self.mapStoresAndLastAppointment(data, response);
                var r = {
                    success: true,
                    stores: data
                };
                self.cache = {};
                self.cache[key] = r;
                d.resolve(self.cache[key]);
            });
        }

        if (self.cache[key]) {
            d.resolve(self.cache[key]);
        }
        else {
            storeBackend.search(query).then(success, function(err) {
                d.reject({
                    success: false,
                    error: err
                });
            });
        }

        return d.promise;
    };

    self.advanceSearch = function(query) {
        let d = $q.defer(),
            key = JSON.stringify(query);
        const urlParams = new URLSearchParams(query);
        const params = Object.fromEntries(urlParams);

        function success(data) {
            let storePromise;
            storePromise = self.getLastAppointmentsForEachStores(data);
            storePromise.then(function(response) {
                data = self.mapStoresAndLastAppointment(data, response);
                let r = {
                    success: true,
                    stores: data
                };
                self.cache = {};
                self.cache[key] = r;
                d.resolve(self.cache[key]);
            });
        }

        if (self.cache[key]) {
            d.resolve(self.cache[key]);
        }
        else {
            storeBackend.advanceSearch(params).then(success, function(err) {
                d.reject({
                    success: false,
                    error: err
                });
            });
        }
        return d.promise;
    };

    self.generateCsv = function(data) {
        return new Promise(function(resolve, reject) {
            return storeBackend.generateCsv(data).then(function(res) {
                let file = new Blob([res],{ type: 'text/csv; charset=utf-8' });
                resolve(URL.createObjectURL(file));
            }).catch(err => reject(err));
        });
    };

    self.getStoresByUserSectors = function() {
        return storeBackend.getStoresByUserSectors();
    };

    self.hasStores = function() {
        return localStorageService.get(LASTUPDATED_KEY) != null;
    };

    self.lastUpdated = function() {
        var mark = localStorageService.get(LASTUPDATED_KEY);
        return mark && new Date(mark);
    };

    self.updateStoreComment = function(data, storeId) {
        return storeBackend.updateStoreComment(data, storeId)
    };

    self.updateStoreContact = function(data, storeId) {
        let contact = {
            mail: data.mail || '',
            telephone_fixe: data.telephones_fixe.length > 0 ? data.telephones_fixe[0] : '',
            telephone_fixe_2: data.telephone_fixe_2 || '',
            telephone_portable: data.telephones_portable.length > 0 ? data.telephones_portable[0] : '',
            numero_fax: data.numero_fax || '',
            adresse: data.adresse,
            complement_adresse: data.complement_adresse || ''
        };
        Object.keys(contact).map(k => contact[k] = typeof contact[k] === 'string' ? contact[k].trim() : contact[k]);
        Object.keys(contact).map(k => {if(contact[k] === ''){delete contact[k]}});
        return storeBackend.updateStoreContact(contact, storeId);
    };

    self.updateStoreCustomer = function(data, storeId) {
        let customer = {
            nom_client: data.nom_client || '',
            prenom_client: data.prenom_client || '',
            identifiant_client: data.identifiant_client,
            sexe_client: data.sexe_client
        };
        console.log(customer);
        Object.keys(customer).map(k => customer[k] = typeof customer[k] === 'string' ? customer[k].trim() : customer[k]);
        Object.keys(customer).map(k => {if(customer[k] === ''){delete customer[k]}});
        return storeBackend.updateStoreCustomer(customer, storeId);
    };

    /**
     * Download stores in selected departments
     */
    self.download = function(list, searchElement) {
        var d = $q.defer();

        if (list.length) {
            // Récupération des stores
            var promise;
            var storePromise;
            if (searchElement === 'departement') {
                promise = storeBackend.downloadStoreDpt(list);
            }
            else if (searchElement === 'city') {
                promise = storeBackend.downloadStoreCity(list);
            }
            else {
                return;
            }

            promise.then(function(stores) {
                var remaining = stores.length;
                d.notify({
                    percent: 10,
                    status: 'primary',
                    message: remaining + ' fiches à sauvegarder.'
                });

                self.clearDirtyIds();
                // Suppression des anciens stores
                self.clear().then(function() {
                    // Enregistrement des nouveaux stores
                    self.add(stores).then(
                        function() {
                            localStorageService.set(LASTUPDATED_KEY, new Date().toISOString());
                            storePromise = self.getLastAppointmentsForEachStores(stores);
                            storePromise.then(function(response) {
                                self.stores = self.mapStoresAndLastAppointment(stores, response);
                                d.resolve(self.stores);
                            });
                        },
                        d.reject.bind(d),
                        function(storeid) {
                            d.notify({
                                percent: Number(10 + (90 * (stores.length - remaining--)) / stores.length).toFixed(0),
                                status: 'success',
                                message: remaining + ' fiches restantes'
                            });
                        }
                    );
                }, d.reject.bind(d));
            }, d.reject.bind(d));
        }
        return d.promise;
    };

    self.addToLocalStore = function(stores) {
        self.clearDirtyIds();
        return self.clear().then(function() {
            return self.add(stores).then(function() {
                localStorageService.set(LASTUPDATED_KEY, new Date().toISOString());
            });
        });
    };

    /**
     * Get the last appointment for each stores
     * @param stores
     */
    self.getLastAppointmentsForEachStores = function(stores) {
        let storesIds = [];
        let storePromise;

        stores.forEach(function(store) {
            storesIds.push(store['identifiant_magasin']);
        });
        // Récupération de la date du dernier rendez-vous pour chaque magasin
        storePromise = storeBackend.downloadLastAppointmentForEachStore(storesIds);
        return storePromise;
    };

    /**
     * Add date of the last appointment for each store
     * @param stores
     * @param lastAppointmentDates
     */
    self.mapStoresAndLastAppointment = function(stores, lastAppointmentDates) {
        stores.forEach(function(store) {
            store.date_dernier_rdv = lastAppointmentDates[store['identifiant_magasin']];
        });
        return stores;
    };

    /**
     * Clear all stores stored in indexedDB
     * @returns {*}
     */
    self.clear = function() {
        return $indexedDB.openStore('Stores', function(objectStore) {
            localStorageService.set(LASTUPDATED_KEY, null);
            self.cache = {}; //
            self.stores = false;
            return objectStore.clear();
        });
    };

    /**
     * Add stores collection to indexedDB
     * @param stores
     */
    self.add = function(stores) {
        var d = $q.defer();
        $indexedDB.openStore('Stores', function(objectStore) {
            return objectStore.insert(stores).then(d.resolve.bind(d), d.reject.bind(d), d.notify.bind(d));
        });
        return d.promise;
    };

    self.getDirtyIds = function() {
        var dirty = localStorageService.get(DIRTY_IDS_KEY);
        dirty = dirty ? JSON.parse(dirty) : [];
        return dirty;
    };

    self.clearDirtyIds = function() {
        localStorageService.set(DIRTY_IDS_KEY, null);
    };

    self.addDirtyId = function(storeid) {
        var dirty = self.getDirtyIds();
        if (dirty.indexOf(storeid) < 0) {
            // ajout du storeid à la liste de store à envoyer
            dirty.push(storeid);
            localStorageService.set(DIRTY_IDS_KEY, JSON.stringify(dirty));
        }
    };

    self.removeDirtyId = function(storeid) {
        var dirty = self.getDirtyIds(),
            index = dirty.indexOf(storeid);
        if (index >= 0) {
            // suppression du storeid à la liste de store à envoyer
            dirty.splice(index, 1);
            localStorageService.set(DIRTY_IDS_KEY, JSON.stringify(dirty));
        }
    };

    /**
     * Add stores collection to indexedDB
     * @param {Object} store
     */
    self.update = function(store) {
        return $indexedDB.openStore('Stores', function(objectStore) {
            return objectStore
                .upsert(store)
                .then(function(res) {
                    self.addDirtyId(store.identifiant_magasin);
                    return store;
                })
                .then(function(store) {
                    return self._sendStore(store);
                });
        });
    };

    self._sendStore = function(store) {
        return storeBackend.upload(store)
            .then(function() {
            $log.info(store.identifiant_magasin, 'successfully updated qualification, activities');
            return self.removeDirtyId(store.identifiant_magasin);
        }, $log.error);
    };

    self.sendUpdates = function() {
        var ids = self.getDirtyIds();
        if (!ids || ids.length == 0) {
            return;
        }
        $log.info('sending ', ids);
        ids.forEach(function(id) {
            self.getById(id).then(
                function(store) {
                    if (!store) {
                        $log.warn('store', id, 'modifié mais absent en local');
                        return self.removeDirtyId(id);
                    }
                    return self._sendStore(store).then(function() {
                        return self._sendStoreHours(store);
                    });
                },
                function(err) {
                    $log.info('impossible de trouver le store', id, 'en local');
                }
            );
        });
    };

    /**
     * Send the updated hours
     * Construct the payload to send to the RFC
     * @param  {Object} store
     * @return {Promise}
     */
    self._sendStoreHours = function(store) {
        var storeHours = {
            horaires_ouverture_lundi: store.horaires_ouverture.lundi,
            horaires_ouverture_mardi: store.horaires_ouverture.mardi,
            horaires_ouverture_mercredi: store.horaires_ouverture.mercredi,
            horaires_ouverture_jeudi: store.horaires_ouverture.jeudi,
            horaires_ouverture_vendredi: store.horaires_ouverture.vendredi,
            horaires_ouverture_samedi: store.horaires_ouverture.samedi,
            horaires_ouverture_dimanche: store.horaires_ouverture.dimanche
        };

        return storeBackend.updateHours(store.identifiant_magasin, storeHours).then(function(data) {
            $log.info(store.identifiant_magasin, 'successfully updated hours');
            return self.removeDirtyId(store.identifiant_magasin);
        }, $log.error);
    };

    self.sendStoreUpdateRequest = function(store, oldStore) {
        return storeBackend
            .sendStoreUpdateRequest(store, oldStore, $root.user)
            .then(function() {
                Notification.success('Demande envoyée avec succès.');
            })
            .catch(err => {
                Notification.error('Une Erreur est survenue');
            });
    };

    self.sendQualificationUpdate = function(store) {
        return storeBackend
            .sendQualificationUpdate(store, $root.user)
            .then(function() {
                Notification.success('Demande envoyée avec succès.');
            })
            .catch(err => {
                Notification.error('Une Erreur est survenue');
            });
    };

    self.updateQualifications = function(store){
        return storeBackend
            .updateQualifications(store)
            .then(function(){
                $log.info(store.identifiant_magasin, 'successfully updated qualification');
            })
    }

    /**
     * Update the store's hours
     * @param  {Object} store
     * @return {Boolean}
     */
    self.updateHours = function(store) {
        return $indexedDB.openStore('Stores', function(objectStore) {
            return objectStore
                .upsert(store)
                .then(function(res) {
                    self.addDirtyId(store.identifiant_magasin);
                    return store;
                })
                .then(function(store) {
                    return self._sendStoreHours(store);
                });
        });
    };

    self.getDateFinContrat = function(store) {
        if(store.etat_magasin === 3 || !store.contracts){
            if(store.qualification.fin_contrat)
                return moment(store.qualification.fin_contrat).get('year') === 1599 ? null : store.qualification.fin_contrat;
            return moment(store.date_fin_de_contrat).get('year') === 1599 ? null : store.date_fin_de_contrat;
        }
        return _getcontractDFC(store.contracts);
    }

    function _getcontractDFC(contracts){
        let mai = contracts.filter(contract => contract.type_contrat === 'MAI');
        mai = mai.sort((contractA, contractB) => {
            return moment(contractB.date_fin_validite).diff(moment(contractA.date_fin_validite));
        });
        return mai[0].date_fin_validite;
    }

    self.getAllServices = function(){
        return storeBackend.getAllServices().then(res => {
            return res;
        });
    }

    self.clearCache = function() {
        return $indexedDB.openStore('Stores', function(objectStore) {
            return objectStore.clear();
        });
    };

    self.updateMoneyTransfertRanking = function (data, filename) {
        return storeBackend.updateMoneyTransfertRanking(filename, data).then(res => {
           return res;
        }).catch(err => Notification.error('Erreur ' + err.data));
    };

    return self;
}
StoreService.$inject = [
    '$q',
    '$rootScope',
    '$indexedDB',
    'storeBackend',
    '$log',
    'localStorageService',
    'Notification'
];

function updater(storeService, $interval, $root, $log) {
    var timer;

    function timerfn() {
        if (!$root.online) {
            $log.info('we are now offline thus I cannot send updates.');
            return;
        }
        storeService.sendUpdates();
    }

    function removetimer() {
        // Make sure that the interval is destroyed too
        return timer && $interval.cancel(timer);
    }

    function addtimer() {
        storeService.sendUpdates();
        return timer || $interval(timerfn, 90 * 1000);
    }

    storeService.sendUpdates();
    timer = addtimer();

    $root.$on('online', addtimer);
    $root.$on('offline', removetimer);
    $root.$on('$destroy', removetimer);
}
updater.$inject = ['storeService', '$interval', '$rootScope', '$log'];

angular
    .module('app.prospection.store.storeService', [])
    .factory('storeService', StoreService);
    // .run(updater);
